export default {"src":"/_next/static/media/identity-line.c9fb2aed.svg","height":128,"width":1273};